import { io, type Socket } from 'socket.io-client';
import { getToken } from './api';

let socket: Socket | null = null;

/**
 * Singleton del socket. Se conecta lazy con el JWT actual.
 * Si el token cambia (logout), el caller debe llamar `disconnect()`.
 */
export function getSocket(): Socket {
  if (socket && socket.connected) return socket;
  const token = getToken();
  socket = io({
    path: '/socket.io',
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });
  return socket;
}

export function disconnectSocket() {
  socket?.disconnect();
  socket = null;
}

export interface BookingChangeEvent {
  bookingId: number;
  itemId: number;
  hierarchyId: string;
  estadoPrevio: string;
  estadoNuevo: string;
  bookingEstado: string;
  bookingJustCompleted?: boolean;
  bookingIdExterno?: string;
  changedBy: { id: number; nombre: string; email: string };
}
